export default __webpack_public_path__ + "static/media/studio-agency.bd77672e.png";